import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 查询客户评定等级
export function listCustomerRatingDifficulty(requestBody) {
  return request({
    url: URL.mdm.basicData.listCustomerRatingDifficulty,
    method: 'post',
    data: requestBody
  })
}

// 新增或更新客户评定等级
export function saveCustomerRatingDifficulty(requestBody) {
  return request({
    url: URL.mdm.basicData.saveCustomerRatingDifficulty,
    method: 'post',
    data: requestBody
  })
}

// 删除客户评定等级
export function deleteCustomerRatingDifficulty(requestBody) {
  return request({
    url: URL.mdm.basicData.deleteCustomerRatingDifficulty,
    method: 'post',
    data: requestBody
  })
}

// 获取已被使用的客户评定等级
export function getUsedCustomerRatingDifficulty(requestBody) {
  return request({
    url: URL.mdm.basicData.getUsedCustomerRatingDifficulty,
    method: 'post',
    data: requestBody
  })
}

// 获取我的客户筛选项
export function getMyCustomerSelectType() {
  return request({
    url: URL.mdm.basicData.getMyCustomerSelectType,
    method: 'get'
  })
}
